/**
 * Backend citation marker grammar — single source of truth.
 * Matches both single and double bracket formats:
 * - [D:1|S:1.2|P:5]
 * - [[D:2|S:1.3|P:3]]
 * - [[D:4|P:1|R:2]] (drawing region)
 * Where D = Document ID, S = Section (optional), P = Pages (optional, can be
 * comma/range like "1,2,3" or "1-5"), R = Region index (optional, for drawing
 * page citations). Supports Unicode dash characters (en dash, em dash,
 * non-breaking hyphen) in page ranges.
 */
export const CITATION_MARKER_SOURCE = String.raw`\[{1,2}D:(\d+)(?:\|S:([^|\]]*))?(?:\|P:([\d,\s\-‐-―]*))?(?:\|R:\d+)?\]{1,2}`;

/**
 * Fresh global `RegExp` per call. A shared `/g` instance carries mutable
 * `lastIndex` state across call sites, so each consumer gets its own.
 */
export const createCitationPattern = (): RegExp => new RegExp(CITATION_MARKER_SOURCE, "g");
